module.exports = __webpack_public_path__ + "img/Facebook.9de70c0a.svg";